import { render, staticRenderFns } from "./medicineInfo.vue?vue&type=template&id=29808e10&scoped=true&"
import script from "./medicineInfo.vue?vue&type=script&lang=js&"
export * from "./medicineInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29808e10",
  null
  
)

export default component.exports